<div class="profile__wrapper">
  <form [formGroup]="personalForm" autocomplete="off">
    <i
      class="icon-pencil"
      [class.grey]="isEditable"
      (click)="switchEdit($event)"
    ></i>
    <fieldset [disabled]="!isEditable" class="form__fieldset">
      <div class="form__row row">
        <div class="form__col col-6">
          <div class="form__title">Location</div>
          <div
            class="row mb-3 location-wrapper d-flex justify-content-start align-items-center"
          >
            <div class="location-wrapper-item">
              <label
                class="location-label label-input white-space-nowrap"
                appMarkAsterisk
                [formGroup]="personalForm"
                [controlName]="'country'"
                [touched]="country.touched"
                >Country
              </label>
              <div class="general_form_input location-input position-relative">
                <div
                  [class.custom-input-empty]="isEditable && !country.value"
                  [class.custom-input-filled]="isEditable && country.value"
                >
                  <app-dropdown
                    ngDefaultControl
                    [border]="'none'"
                    [items]="countryList"
                    formControlName="country"
                    [isEditMode]="isEditable"
                  ></app-dropdown>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('country', personalForm) &&
                      country.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
            </div>
            <div class="location-wrapper-item">
              <label
                class="location-label label-input white-space-nowrap"
                appMarkAsterisk
                [formGroup]="personalForm"
                [controlName]="'city'"
                [touched]="city.touched"
                >City
              </label>
              <div class="general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="city"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('city', personalForm) &&
                    city.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="city.hasError('maxlength')"
                  [errorMessage]="'Max field length = 20'"
                ></app-error-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form__title">Contacts</div>
        <div class="row mb-3">
          <app-messengers
            (messengersChecked)="setPhoneNumber($event)"
            [editMode]="isEditable"
            [phoneData]="phoneNumbersComponentData"
          ></app-messengers>
        </div>
        <div class="location-wrapper-item" formGroupName="email">
          <label
            class="location-label label-input white-space-nowrap"
            appMarkAsterisk
            [formGroup]="personalForm"
            [controlName]="'email'"
            [touched]="email.touched"
            >Personal email
          </label>
          <div class="general_form_input">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="email"
            />
            <app-error-field
              [displayError]="email.hasError('maxlength')"
              [errorMessage]="'Max field length = 30'"
            ></app-error-field>
            <app-error-field
              [displayError]="
                email.hasError('pattern') && !email.hasError('maxlength')
              "
              [errorMessage]="'Please enter a valid email'"
            ></app-error-field>
          </div>
        </div>
        <div class="form__title pt-20">Professional</div>
        <div class="location-wrapper-item">
          <label
            class="location-label label-input white-space-nowrap"
            [formGroup]="personalForm"
            appMarkAsterisk
            [controlName]="'stackTechnology'"
            [touched]="stackTechnology.touched"
            >Tech stack</label
          >
          <app-dropdown
            [items]="stackTechnologyList"
            formControlName="stackTechnology"
            [border]="isEditable ? 'classic' : 'none'"
            [isEditMode]="isEditable"
          ></app-dropdown>
        </div>
      </div>
    </fieldset>
  </form>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    (click)="save()"
    #saveButton
  >
    Save
  </button>
</div>
